import { Row } from '../schemas';

/**
 * 機種集計の平均/合計行。API は null と文字列 'null' の両方を返す。
 */
export const isDataKiAverageTotalRowValue = (
  value: string | null
): value is null | 'null' => value == null || value === 'null';

/**
 * SIS タイプコードで OR 絞り込みする。
 * 未選択時は全件。平均/合計行は残す。
 */
export const filterDataKiRowsBySisTypeCodes = (
  rows: Row[],
  selectedSisTypeCodes: readonly string[]
): Row[] => {
  if (selectedSisTypeCodes.length === 0) {
    return rows;
  }

  const selectedSisTypeCodeSet = new Set(selectedSisTypeCodes);
  return rows.filter((row) => {
    const rowId = row.queryParameter.value as string | null;
    if (isDataKiAverageTotalRowValue(rowId)) {
      return true;
    }
    return selectedSisTypeCodeSet.has(rowId);
  });
};

/**
 * 検索結果テーブル（ヘッダ絞り込み前）に存在する SIS タイプコード。
 * 平均/合計行は含めない。
 */
export const extractSisTypeCodesFromDataKiRows = (rows: Row[]): string[] => {
  const sisTypeCodes: string[] = [];
  for (const row of rows) {
    const rowId = row.queryParameter.value as string | null;
    if (
      typeof rowId === 'string' &&
      rowId !== '' &&
      !isDataKiAverageTotalRowValue(rowId)
    ) {
      sisTypeCodes.push(rowId);
    }
  }
  return sisTypeCodes;
};
